import { render, staticRenderFns } from "./SettingFormDetail.vue?vue&type=template&id=ae0f3866&scoped=true&"
import script from "./SettingFormDetail.vue?vue&type=script&lang=js&"
export * from "./SettingFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./SettingFormDetail.vue?vue&type=style&index=0&id=ae0f3866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0f3866",
  null
  
)

export default component.exports